module.exports = __webpack_public_path__ + "img/rad-conv-gen-2.09d1dbe4.png";